import { render, staticRenderFns } from "./ApprovalForm.vue?vue&type=template&id=650cc4db"
import script from "./ApprovalForm.vue?vue&type=script&lang=ts"
export * from "./ApprovalForm.vue?vue&type=script&lang=ts"
import style0 from "./ApprovalForm.vue?vue&type=style&index=0&id=650cc4db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports